import clsx from 'clsx'
import { useEffect, useState } from 'react'

import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Loading from '../../Loading/Loading'

interface IUploadImage {
    className?: string
    style?: any
    fileChanged?: (file: string) => void
    imageUrl?: string
    isLoading?: boolean
    type?: 'upload-image' | 'upload-profile'
    id?: string
    disabled?: boolean
    removeAction?: () => void
    remove?: boolean
}

const profilePlaceholder = require('@Images/icons/camera-icon.svg').default
const imagePlaceholder = require('@Images/icons/file-icon.svg').default

const UploadImage = (props: IUploadImage) => {
    // core section
    const {
        className,
        style,
        fileChanged,
        imageUrl,
        isLoading,
        type = 'upload-image',
        id = 'upload_image',
        disabled = false,
        removeAction,
        remove = false,
    } = props
    const ac = new AbortController()

    // states section
    const [defaultImage, setDefaultImage] = useState(imagePlaceholder)

    // hooks section
    useEffect(() => {
        if (type === 'upload-image') {
            setDefaultImage(imagePlaceholder)
        } else {
            setDefaultImage(profilePlaceholder)
        }
        return () => {
            ac.abort()
        }
    }, [type])

    // handle remove action
    const handleRemoveImage = (e: any) => {
        e.stopPropagation()
        e.preventDefault()
        if (removeAction) removeAction()
    }

    // functions section
    function onChange(e: any) {
        e.preventDefault()
        let files
        if (e.dataTransfer) {
            files = e.dataTransfer.files
        } else if (e.target) {
            files = e.target.files
        }
        const reader = new FileReader()
        reader.onload = () => {
            if (fileChanged) fileChanged(reader.result as any)
        }
        reader.readAsDataURL(files[0])
        // clear input file
        e.target.value = []
    }

    return (
        <div
            className={clsx(type, className, 'position-relative p-2')}
            style={style}
        >
            <Loading isLoading={isLoading} />
            <div className={clsx(imageUrl ? 'h-100' : '')}>
                {imageUrl && remove && !disabled ? (
                    <RemoveCircleOutlineIcon
                        className="remove-action"
                        onClick={handleRemoveImage}
                    />
                ) : null}
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        className={clsx(imageUrl ? 'img-uploaded' : '')}
                        alt=""
                    />
                ) : (
                    <>
                        <img src={defaultImage} alt="" />
                        {type === 'upload-image' && (
                            <p className="d-block gray-text m-0 mt-1">
                                Upload Images
                            </p>
                        )}
                    </>
                )}
            </div>
            <label
                htmlFor={id}
                id="input_file_label"
                style={{
                    cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    margin: 0,
                }}
            >
                <input
                    type="file"
                    onChange={onChange}
                    hidden
                    accept=".png, .jpeg, .jpg"
                    id={id}
                    disabled={disabled}
                />
            </label>
        </div>
    )
}

export default UploadImage
